import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import GoogleCallback from "@/pages/GoogleCallback";
import Legal from "@/pages/Legal";
import LanguageToggle from "@/components/LanguageToggle";

// Admin
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminOrders from "@/admin/AdminOrders";
import AdminMandaditos from "@/admin/AdminMandaditos";
import AdminRestaurants from "@/admin/AdminRestaurants";
import AdminDrivers from "@/admin/AdminDrivers";
import AdminDriverNotifications from "@/admin/AdminDriverNotifications";
import AdminCustomerNotifications from "@/admin/AdminCustomerNotifications";
import AdminAccess from "@/admin/AdminAccess";
import AdminDriverStats from "@/admin/AdminDriverStats";
import AdminDispatch from "@/admin/AdminDispatch";
import AdminUsers from "@/admin/AdminUsers";
import AdminPayments from "@/admin/AdminPayments";
import AdminReports from "@/admin/AdminReports";
import AdminNotifications from "@/admin/AdminNotifications";
import AdminSettings from "@/admin/AdminSettings";
import AdminAreas from "@/admin/AdminAreas";
import AdminPackagePricing from "@/admin/AdminPackagePricing";
import { ChatNotifications } from '@/components/OrderChat';
import SoundGate from "@/components/SoundGate";
import { TARGET_APP, prepareNativeShell } from "@/lib/native";

// Customer app
import CustomerApp from "@/customer/CustomerApp";
// Driver app
import DriverApp from "@/driver/DriverApp";
// Restaurant portal
import RestaurantPortal from "@/restaurant/RestaurantPortal";

const AppRoutes = () => (
        <Routes>
          <Route path="/auth/google" element={<GoogleCallback />} />
          <Route path="/privacidad" element={<Legal />} />
          <Route path="/terminos" element={<Legal />} />
          <Route path="/eliminar-cuenta" element={<Legal />} />
          <Route path="/" element={TARGET_APP === 'customer' ? <Navigate to="/app" replace /> : TARGET_APP === 'driver' ? <Navigate to="/driver" replace /> : <Landing />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="pedidos" element={<AdminOrders />} />
            <Route path="mandaditos" element={<AdminMandaditos />} />
            <Route path="restaurantes" element={<AdminRestaurants />} />
            <Route path="conductores" element={<AdminDrivers />} />
            <Route path="estadisticas-conductores" element={<AdminDriverStats />} />
            <Route path="pago-y-asignacion" element={<AdminDispatch />} />
            <Route path="avisos-conductores" element={<AdminDriverNotifications />} />
            <Route path="promociones-clientes" element={<AdminCustomerNotifications />} />
            <Route path="accesos" element={<AdminAccess />} />
            <Route path="usuarios" element={<AdminUsers />} />
            <Route path="pagos" element={<AdminPayments />} />
            <Route path="reportes" element={<AdminReports />} />
            <Route path="notificaciones" element={<AdminNotifications />} />
            <Route path="configuracion" element={<AdminSettings />} />
            <Route path="zonas" element={<AdminAreas />} />
            <Route path="tarifas-encomiendas" element={<AdminPackagePricing />} />
          </Route>

          <Route path="/app/*" element={<CustomerApp />} />
          <Route path="/driver/*" element={<DriverApp />} />
          <Route path="/restaurant/*" element={<RestaurantPortal />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
);

function App() {
  React.useEffect(() => { prepareNativeShell(); }, []);
  return (
    <AppProvider>
      <BrowserRouter>
        <ChatNotifications />
        <SoundGate />
        <AppRoutes />
      </BrowserRouter>
      <LanguageToggle />
      <Toaster position="top-center" richColors />
    </AppProvider>
  );
}

export default App;
